// TODO at some point this should likely be the result of counting instructors from the API
const NUMBER_OF_INSTRUCTORS = 200

export const getNumberOfInstructors = () => NUMBER_OF_INSTRUCTORS
